import { useEffect, useState } from "react";
import { IMAGES } from "../../../assets";
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <section className="footer-section">
      <div className="container">
        <div className="middle-portion">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4 col-12">
              <div className="icons">
                <a href="/">
                  <figure className="footer-logo">
                    <img src={IMAGES.footer_logo} alt="" />
                  </figure>
                </a>
                <ul className="list-unstyled mb-0">
                  <li>
                    <a href="#">
                      <Facebook style={{ color:"#4F309E" }}/>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <Twitter style={{ color:"#4F309E" }}/>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <Linkedin style={{ color:"#4F309E" }}/>
                    </a>
                  </li>
                  {/* <li>
                    <a href="#">
                      <i className="fa-brands fa-pinterest"></i>
                    </a>
                  </li> */}
                  <li>
                    <a href="">
                      <Instagram style={{ color:"#4F309E" }}/>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-6">
              <div className="links">
                <h3 className="heading">Services</h3>
                <ul className="list-unstyled mb-0">
                  <li>
                    <a
                      href="/#statistics"
                      className=" text text-decoration-none"
                    >
                      Astrology
                    </a>
                  </li>
                  <li>
                    <a
                      href="/#basic-feature"
                      className=" text text-decoration-none"
                    >
                      Horosscope
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-6">
              <div className="links">
                <h3 className="heading">Quick Links</h3>
                <ul className="list-unstyled mb-0">
                  <li>
                    <a
                      href="/"
                      className=" text text-decoration-none"
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="/about-us" className=" text text-decoration-none">
                      About us
                    </a>
                  </li>
                  <li>
                    <a
                      href="/#contact"
                      className=" text text-decoration-none"
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-lower">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <p className="mb-0 text-size-18">
                © 2025 <a href="/">Cosmic Advice</a>. All Rights Reserved
              </p>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <p className="mb-0 term text-size-18">
                <a href="/terms-of-use">Term of Use</a> | <a href="/privacy-policy">Privacy Policy</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
